import { render, staticRenderFns } from "./NavItemDropdownItem.vue?vue&type=template&id=2c49abb8&"
import script from "./NavItemDropdownItem.vue?vue&type=script&lang=js&"
export * from "./NavItemDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports